export * from './consumidor.model';
export * from './consumidor.service';
export * from './consumidor-bilhetes.service';
export * from './consumidor-bilhetes.model';
export * from './consumidor-previsao.model';



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/shared/index.ts